// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.chat_message_status_enum */
var ChatMessageStatusEnum;
(function (ChatMessageStatusEnum) {
    ChatMessageStatusEnum["pending"] = "pending";
    ChatMessageStatusEnum["success"] = "success";
    ChatMessageStatusEnum["error"] = "error";
})(ChatMessageStatusEnum || (ChatMessageStatusEnum = {}));
;
export default ChatMessageStatusEnum;
/** Zod schema for chat_message_status_enum */
export const chatMessageStatusEnum = z.nativeEnum(ChatMessageStatusEnum);
//# sourceMappingURL=ChatMessageStatusEnum.js.map